import { useParams } from 'react-router-dom'
import { Grid } from '@mui/material'

import { TEMPLATES_ENDPOINTS, useGetTemplatePayment } from '../../services'
import { DataBlock, RefetchMessage, SendUrlButton, ViewPaymentSkeleton } from '../../components'

import { ADDITIONAL_INFO_LABELS, MAIN_INFO_LABELS } from './constants.ts'

export const TemplatePaymentView = () => {
  const { id = '' } = useParams<{ id: string }>()

  const { data, isError, refetch, isRefetching, isLoading } = useGetTemplatePayment(id)

  if (!data?.data.id || isLoading) return <ViewPaymentSkeleton />

  if (isError) {
    return <RefetchMessage refetch={refetch} isRefetching={isRefetching} />
  }

  return (
    <Grid container flexDirection="row" spacing={{ xs: 2, lg: 4 }}>
      <Grid item xs={12} md={6}>
        <DataBlock items={MAIN_INFO_LABELS} data={data.data}>
          <SendUrlButton {...data.data} sendUrl={TEMPLATES_ENDPOINTS.sendUrl} title="Отправить ссылку" />
        </DataBlock>
      </Grid>
      <Grid item xs={12} md={6}>
        <DataBlock items={ADDITIONAL_INFO_LABELS} data={data.data} />
      </Grid>
    </Grid>
  )
}
